import { Label, Scale } from "@mui/icons-material";
import { CircularGauge } from "devextreme-react";
import { Geometry, ValueIndicator, Animation } from "devextreme-react/cjs/circular-gauge";
import React, { useState, useEffect } from 'react';
import "./TopBuyerShareChart.css";

export const TopBuyerShareChart = (props) => {
    const topBuyerShare = Number.parseFloat(props.topBuyerShare).toFixed(1);
    const divCircularGraphId = "textCloud";
    const [isSmallScreenSize, setIsSmallScreenSize] = useState(false);
 
    function handleResize() {
        const divCircularGraphObj = document.getElementById(divCircularGraphId);
        if (divCircularGraphObj) {
            // Update breakpoint to 300px for better mobile experience
            const isSmall = (divCircularGraphObj.offsetWidth < 300)? true : false;
            setIsSmallScreenSize(isSmall);
        }
    }

    // Add useEffect to check size on mount and window resize
    React.useEffect(() => {
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
   
    const customizeText = ({ valueText }) => {
        return `${valueText} %`;
    };

    const customTicks = [0, 20, 40, 60, 80, 100];

    return (
        <>
            <div className="header-Text">
                Top Buyer Share:
            </div>
            {isSmallScreenSize ? (
                <div className="mobile-gauge-view">
                    <div className="mobile-gauge-value">{topBuyerShare}%</div>
                    <div className="mobile-gauge-scale">
                        <div className="scale-line">
                            <span>0%</span>
                            <div className="progress-bar">
                                <div 
                                    className="progress-fill" 
                                    style={{width: `${topBuyerShare}%`}}
                                />
                            </div>
                            <span>100%</span>
                        </div>
                    </div>
                </div>
            ) : (
                <CircularGauge
                    id={divCircularGraphId}
                    value={topBuyerShare}
                    height={160}
                    onDrawn={handleResize}
                >
                    <ValueIndicator
                        type="textCloud"
                        color="#483D8B"
                        customizeText={customizeText}
                        size={28}
                    ></ValueIndicator>
                    <Scale startValue={0} endValue={100} tickInterval={20} customTicks={customTicks}>
                        <Label 
                            customizeText={customizeText}
                            font={{ size: 14 }}
                            indentFromTick={7}
                        ></Label>
                    </Scale>
                    <Geometry startAngle={180} endAngle={0}></Geometry>
                    <Animation
                        enabled={false}
                    />
                </CircularGauge>
            )}
        </>
    )
}
